var map = {
	"./AboutPage": [
		5703,
		594
	],
	"./AboutPage.tsx": [
		5703,
		594
	],
	"./AssembliesPage": [
		5377,
		384,
		758
	],
	"./AssembliesPage.tsx": [
		5377,
		384,
		758
	],
	"./AssortmentPage": [
		8669,
		155
	],
	"./AssortmentPage.tsx": [
		8669,
		155
	],
	"./Batteries18650Page": [
		159,
		384,
		159
	],
	"./Batteries18650Page.tsx": [
		159,
		384,
		159
	],
	"./Batteries21700Page": [
		5093,
		384,
		93
	],
	"./Batteries21700Page.tsx": [
		5093,
		384,
		93
	],
	"./BatteriesForFPVPage": [
		7378,
		384,
		378
	],
	"./BatteriesForFPVPage.tsx": [
		7378,
		384,
		378
	],
	"./BatteriesForToysPage": [
		1453,
		384,
		453
	],
	"./BatteriesForToysPage.tsx": [
		1453,
		384,
		453
	],
	"./BatteriesForTransportPage": [
		1401,
		384,
		401
	],
	"./BatteriesForTransportPage.tsx": [
		1401,
		384,
		401
	],
	"./BatteriesPage": [
		7369,
		384,
		369
	],
	"./BatteriesPage.tsx": [
		7369,
		384,
		369
	],
	"./CardPage": [
		342,
		437,
		377,
		416,
		748
	],
	"./CardPage.tsx": [
		342,
		437,
		377,
		416,
		748
	],
	"./CheckoutPage": [
		5360,
		220,
		536,
		828,
		360
	],
	"./CheckoutPage.tsx": [
		5360,
		220,
		536,
		828,
		360
	],
	"./ContactsPage": [
		6781,
		781
	],
	"./ContactsPage.tsx": [
		6781,
		781
	],
	"./DeliveryPaymentPage": [
		1960,
		960
	],
	"./DeliveryPaymentPage.jsx": [
		1960,
		960
	],
	"./DevicesPage": [
		6267,
		384,
		267
	],
	"./DevicesPage.tsx": [
		6267,
		384,
		267
	],
	"./FavoritesPage": [
		9659,
		617
	],
	"./FavoritesPage.tsx": [
		9659,
		617
	],
	"./GuaranteesPage": [
		7607,
		607
	],
	"./GuaranteesPage.jsx": [
		7607,
		607
	],
	"./MainPage": [
		7186,
		186
	],
	"./MainPage.tsx": [
		7186,
		186
	],
	"./MaterialsPage": [
		7740,
		384,
		740
	],
	"./MaterialsPage.tsx": [
		7740,
		384,
		740
	],
	"./OrdersHistoryPage": [
		7000,
		498,
		456
	],
	"./OrdersHistoryPage.tsx": [
		7000,
		498,
		456
	],
	"./PaymentResultPage": [
		5800,
		800
	],
	"./PaymentResultPage.tsx": [
		5800,
		800
	],
	"./Print3DPage": [
		6627,
		220,
		437,
		416,
		869
	],
	"./Print3DPage.tsx": [
		6627,
		220,
		437,
		416,
		869
	],
	"./PrivacyPolicyPage": [
		9087,
		87
	],
	"./PrivacyPolicyPage.tsx": [
		9087,
		87
	],
	"./SalesPage": [
		166,
		384,
		166
	],
	"./SalesPage.tsx": [
		166,
		384,
		166
	],
	"./UserProfilePage": [
		8998,
		220,
		536,
		299,
		998
	],
	"./UserProfilePage.tsx": [
		8998,
		220,
		536,
		299,
		998
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;